;(function ($, window, document) {
    /**
     * Disable window scrolling.
     *
     * @param  {boolean} hideScrollbar - If scrollbar should be hidden.
     * @returns {void}
     */
    function disableScroll(hideScrollbar) {
        if (!$('body').hasClass('scroll-disabled')) {
            var curScroll = $(window).scrollTop();

            $('body').addClass('scroll-disabled');
            if (hideScrollbar) {
                $('body').addClass('scroll-disabled--hide-scrollbar');
            }
            $('body').css('top', -curScroll);
        }
    }

    /**
     * Enable window scrolling.
     *
     * @returns {void}
     */
    function enableScroll() {
        var bodyScroll = parseInt($('body').css('top'), 10);

        $('body').removeClass('scroll-disabled scroll-disabled--hide-scrollbar');
        if (bodyScroll) {
            $(window).scrollTop(-bodyScroll);
            $('body').css('top', 0);
        }
    }

    window.disableScroll = disableScroll;
    window.enableScroll = enableScroll;
})(jQuery, window, document);

;(function ($, window, document) {
    var pluginName = 'rkasModal';
    var defaults = {};
    var initSelector = '.modal';

    /**
     * Modal.
     *
     * @class
     * @param {HTMLElement} element - The HTML element the Modal should be bound to.
     * @param {Object} options - An option map.
     */
    function Modal(element, options) {
        this.element = element;
        this.$element = $(this.element);
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.container = false;

        this.init();
    }

    /**
     * Initialize the plugin.
     *
     * @function init
     * @returns {void}
     */
    Modal.prototype.init = function () {
    };

    /**
     * Open modal.
     *
     * @function open
     * @param  {HTMLElement} trigger - Trigger element.
     * @returns {void}
     */
    Modal.prototype.open = function (trigger) {
        if ($('.modal-container--visible').length > 0) {
            $('.modal-container--visible').each(function () {
                $(this).find(initSelector)[pluginName]('close');
            });
        }

        var that = this;
        var e = $.Event('open.rkas.modal');

        this.$element.trigger(e);

        if (!this.container.length) {
            this.container = $('<div class="modal-container"></div>');
            this.inner = $('<div class="modal-container__inner"></div>');

            this.container.on('click.rkas.modal.close', function (event) {
                if (event.target === event.currentTarget) {
                    event.preventDefault();
                    that.close();
                }
            });

            // force re-rendering of icons to fix a very weird chrome bug
            this.$element.find('.icon').each(function () {
                $(this).html($(this).html());
            });

            this.inner.append(this.$element);
            this.container.append(this.inner);

            $('body').append(this.container);
        }

        var _close = this.$element.find('.modal__close');
        if (_close.length == 0) {
            this.closeBtn = $('<button class="modal__close">' + rkas.icon.render('#close') + '</button>');

            this.$element.prepend(this.closeBtn);
        } else {
            this.closeBtn = _close;
        }
        this.closeBtn.on('click.rkas.modal.close', function (event) {
            event.preventDefault();
            that.close();
        });

        this.container.addClass('modal-container--visible');

        window.disableScroll(true);
        $(document).on('keyup.rkas.modal', this.keyboard.bind(this));
        $(window).trigger('resize');
        $(document).trigger('refresh.rkas', [this.element, trigger]);
    };

    /**
     * Close modal on esc.
     *
     * @function keyboard
     * @param  {Event} event - Event.
     * @returns {void}
     */
    Modal.prototype.keyboard = function (event) {
        if (event.keyCode == 27) {
            this.close();
        }
    };

    /**
     * Close modal.
     *
     * @function close
     * @returns {void}
     */
    Modal.prototype.close = function () {
        $(document).trigger('reset.rkas', this.$element[0]);
        this.container.removeClass('modal-container--visible');
        window.enableScroll();
        var e = $.Event('close.rkas.modal');

        this.$element.trigger(e);
        $(document).off('keyup.rkas.modal');
    };

    /**
     * Destroy the plugin instance.
     *
     * @function destroy
     * @returns {void}
     */
    Modal.prototype.destroy = function () {
        this.$element.removeData('plugin_' + pluginName);
    };

    /**
     * Create jQuery plugin.
     *
     * @param {Object} options - Extended options.
     * @listens rkas.modal
     * @returns {Array<Modal>} Array of Modals.
     */
    $.fn[pluginName] = function (options) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var instance = $.data(this, 'plugin_' + pluginName);

            if (!instance) {
                if (options === 'destroy') {
                    return;
                }

                $.data(this, 'plugin_' + pluginName, new Modal(this, options));
            } else if (typeof options === 'string') {
                instance[options].apply(instance, args);
            }
        });
    };

    /**
     * @param {Event} event
     * @event enhance.rkas.modal
     */
    $(document).on('enhance.rkas.modal', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]();
    });

    /**
     * @param {Event} event
     * @event destroy.rkas.modal
     */
    $(document).on('destroy.rkas.modal', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]('destroy');
    });

    /**
     * @param  {Event} event
     * @event click.rkas.modal.open
     */
    $(document).on('click.rkas.modal.open', '.js-modal', function (event) {
        event.preventDefault();
        var $this = $(this);
        var trigger = $(event.currentTarget);
        var target = false;

        if ($this.attr('data-modal-target')) {
            target = $this.attr('data-modal-target');
        } else if ($this.attr('href')) {
            target = $this.attr('href');
        }

        if (target) {
            $(target)[pluginName]('open', trigger);
        }
    });

    /**
     * Auto-init the plugin on DOM ready.
     * @fires enhance.rkas.modal
     */
    $(function () {
        $(document).trigger('enhance.rkas.modal');
    });

    /**
     * Old init for compatibility.
     *
     * @fires enhance.rkas.modal
     * @deprecated Use enhance.rkas.modal event directly.
     * @returns {void}
     */
    function initModal() {
        $(document).trigger('enhance.rkas.modal');
    }

    window.initModal = initModal;

})(jQuery, window, document);
